import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { useAuthStore } from '@/stores/authStore'
import type { AppUser } from '@/types/app'

const KEY = (rid: string) => ['team', rid]

export function useTeamMembers() {
  const restaurantId = useAuthStore(s => s.restaurant?.id ?? '')
  return useQuery({
    queryKey: KEY(restaurantId),
    queryFn: async () => {
      const { data, error } = await supabase
        .from('users')
        .select('*')
        .eq('restaurant_id', restaurantId)
        .order('role')
      if (error) throw error
      return (data ?? []) as AppUser[]
    },
    enabled: !!restaurantId,
  })
}

export function useSaveTeamMember() {
  const restaurantId = useAuthStore(s => s.restaurant?.id ?? '')
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (patch: Pick<AppUser, 'id'> & Partial<Pick<AppUser, 'full_name' | 'phone' | 'is_active' | 'role'>>) => {
      const { id, ...rest } = patch
      const { data, error } = await supabase
        .from('users')
        .update({ ...rest, updated_at: new Date().toISOString() } as Record<string, unknown>)
        .eq('id', id)
        .select()
        .single()
      if (error) throw error
      return data as AppUser
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY(restaurantId) }),
  })
}
